import { __assign } from "tslib";
import { usePress } from '../../interactions/press';
import { useFocusManager } from '../../libs/focus';
import { useUniqId } from '../../libs/uniq-id';
export function useDateTimeField(props) {
    var focusNext = useFocusManager().focusNext;
    var id = useUniqId(props.id);
    var pressProps = usePress({
        onPressStart: function (event) {
            var currentTarget = event.currentTarget, target = event.target, source = event.source;
            var activeElement = document.activeElement;
            if (source !== 'mouse') {
                return;
            }
            if (!currentTarget.contains(activeElement) ||
                (target !== activeElement && target !== currentTarget)) {
                focusNext({ from: target, tabbable: true });
            }
        },
    }).pressProps;
    var fieldProps = __assign(__assign({}, pressProps), { role: 'group', id: id, 'aria-label': props['aria-label'], 'aria-labelledby': props['aria-labelledby'] });
    var segmentProps = {
        'aria-controls': props['aria-controls'],
        'aria-haspopup': props['aria-haspopup'],
        'aria-invalid': props['aria-invalid'],
        'aria-labelledby': fieldProps['aria-labelledby'] || fieldProps.id,
    };
    return {
        fieldProps: fieldProps,
        segmentProps: segmentProps,
    };
}
